var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bigmodal',{attrs:{"title":_vm.lang['MyReferrals']},on:{"close":function($event){return _vm.$emit('close')}}},[_vm._v(" "+_vm._s(_vm.form)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }